export const MAX_MANUAL_ENTRIES = 20;

export const MANUAL_ENTRY_CHANNELS = {
  MPESA: "Mpesa",
  AIRTEL: "Airtel",
  BANK: "Bank",
};

export const MANUAL_ENTRY_CHANNEL_OPTIONS = [
  { value: MANUAL_ENTRY_CHANNELS.MPESA, label: "M-Pesa" },
  { value: MANUAL_ENTRY_CHANNELS.AIRTEL, label: "Airtel" },
  { value: MANUAL_ENTRY_CHANNELS.BANK, label: "Bank" },
];

export const CHANNEL_TO_PROVIDER = {
  [MANUAL_ENTRY_CHANNELS.MPESA]: "Safaricom",
  [MANUAL_ENTRY_CHANNELS.AIRTEL]: "Airtel",
};

export const BANK_MIN_AMOUNT = 10;
